/* eslint-disable */

const modalStore = {
  state: {
    openModal: false,
    message: '',
  },
  getters: {
    open(state) {
      return state.openModal;
    },
    message(state) {
      return state.message;
    }
  },
  mutations: {
    CLOSE_MODAL(state) {
      state.openModal = false;
    },
    OPEN_MODAL(state) {
      state.openModal = true;
    },
    UPDATE_MESSAGE(state, payload) {
      state.message = payload;
    }
  }
};
export default modalStore;
